import { useCallback, useMemo, useState } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Card } from "reactstrap";
import CreateReport from "./CreateReport";
import { ReportColumnsProvider } from "./CreateReport/context";
import ReportDisplay from "./CreateReport/ReportDispaly";
import Home from "./Home";
import "./style.scss";

function CustomReports() {
	const [step, setStep] = useState(0);
	const [mode, setMode] = useState(null);
	const [data, setData] = useState({
		name: "",
		columns: [],
		columnLabels: {},
		id: undefined,
	});

	const onCancel = useCallback(() => {
		setStep(0);
		setData({
			name: "",
			columns: [],
			columnLabels: {},
			id: undefined
		});
	}, [setStep, setData]);

	const content = useMemo(() => {
		switch (step) {
			case 1:
				return (
					<CreateReport
						onCancel={onCancel}
						setStep={setStep}
						setData={setData}
						data={data}
						mode={mode}
					/>
				);
			case 2:
				return <ReportDisplay data={data} goBack={onCancel} />;
			case 0:
			default:
				return (
					<Home
						setStep={setStep}
						setData={setData}
						data={data}
						setMode={setMode}
					/>
				);
		}
	}, [step, data, setData, setStep, onCancel, mode]);

	return (
		<ReportColumnsProvider>
			<Card className="h-100">
				<DndProvider backend={HTML5Backend}>{content}</DndProvider>
			</Card>
		</ReportColumnsProvider>
	);
}

export default CustomReports;
